import {Box, Button, Grid, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {WarningAmberRounded} from "@mui/icons-material";

const NotAuthorizedPage = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const handleClick = () => {
        navigate("/");
    }
    return (
        <Box sx={{height: '90vh', display: 'flex', alignItems: 'center', textAlign: 'center'}}>
            <Grid container>
                <Grid xs={12} mb={2}><WarningAmberRounded sx={{fontSize: '5rem'}} color={'error'}/></Grid>
                <Grid xs={12} mb={2}><Typography variant={"h4"}>{t('error.notAuthorized')}</Typography></Grid>
                <Grid xs={12} mb={4}><Typography
                    variant={"subtitle1"}>{t('error.notAuthorizedMessage')}</Typography></Grid>
                <Grid xs={12}><Button variant={"outlined"} color={"accent"} onClick={handleClick}
                                      size={"large"}>{t('pageNotFound.button')}</Button></Grid>
            </Grid>
        </Box>
    );
}

export default NotAuthorizedPage;
